import config from 'init/config';
import { fRequest } from 'utilities/api';

export const api_add_advanced_request = data =>
  fRequest(`${config.buckRootUrl}/order/advanced_requests/`, {
    method: 'POST',
    data: data
  });
